import type { RunIndexEntry } from '@yancheng/contracts';
import { idToken } from './auth';
import type { RuntimeConfig } from './config';

export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
    this.name = 'ApiError';
  }
}

async function getJson<T>(config: RuntimeConfig, path: string): Promise<T> {
  const response = await fetch(`${config.apiUrl.replace(/\/$/, '')}${path}`, {
    headers: { Authorization: await idToken() },
    cache: 'no-store'
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({})) as { error?: string };
    throw new ApiError(payload.error ?? `Request failed (${response.status})`, response.status);
  }
  return response.json() as Promise<T>;
}

export function listRuns(config: RuntimeConfig, projectId: string) {
  return getJson<{ projectId: string; runs: RunIndexEntry[]; nextCursor: string | null }>(config, `/v1/research/projects/${encodeURIComponent(projectId)}/runs`);
}

export function getRun(config: RuntimeConfig, projectId: string, runId: string) {
  return getJson<Record<string, unknown>>(config, `/v1/research/projects/${encodeURIComponent(projectId)}/runs/${encodeURIComponent(runId)}`);
}

export function getItem(config: RuntimeConfig, projectId: string, itemId: string) {
  return getJson<Record<string, unknown>>(config, `/v1/research/projects/${encodeURIComponent(projectId)}/items/${encodeURIComponent(itemId)}`);
}
